export const SITE_ORIGIN = 'https://webcodecraft.co.uk';

export const BLOG_SLUG_FREE_WEBSITE_UK = 'free-websites-uk-builders';

export function blogArticleUrl(slug) {
  return `${SITE_ORIGIN}/blog/${slug}`;
}

export function internalUrl(hashOrId) {
  const id = hashOrId.replace(/^#/, '');
  if (id === 'client-review') {
    return `${SITE_ORIGIN}/#client-review`;
  }
  if (id === 'services') {
    return `${SITE_ORIGIN}/services`;
  }
  if (id === 'ecommerce-web-apps' || id === 'ecommerce') {
    return `${SITE_ORIGIN}/ecommerce-web-apps`;
  }
  if (id === 'faq') {
    return `${SITE_ORIGIN}/faq`;
  }
  if (id === 'guides') {
    return `${SITE_ORIGIN}/guides`;
  }
  if (id === 'tax-calculator') {
    return `${SITE_ORIGIN}/website-tax-calculator`;
  }
  if (id === 'check-your-seo') {
    return `${SITE_ORIGIN}/check-your-seo`;
  }
  if (id === 'accessibility-check') {
    return `${SITE_ORIGIN}/accessibility-check`;
  }
  if (id === 'reading-time-tool') {
    return `${SITE_ORIGIN}/reading-time-tool`;
  }
  if (id === 'scope-estimator') {
    return `${SITE_ORIGIN}/scope-estimator`;
  }
  if (id === 'competitor-tracker') {
    return `${SITE_ORIGIN}/competitor-tracker`;
  }
  if (id === 'serp-overview') {
    return `${SITE_ORIGIN}/serp-overview`;
  }
  if (id === 'keywords-explorer') {
    return `${SITE_ORIGIN}/keywords-explorer`;
  }
  if (id === 'website-crawler') {
    return `${SITE_ORIGIN}/website-crawler`;
  }
  if (id === 'backlink-checker') {
    return `${SITE_ORIGIN}/backlink-checker`;
  }
  if (id === 'locations') {
    return `${SITE_ORIGIN}/locations`;
  }
  if (id === 'trades') {
    return `${SITE_ORIGIN}/trades`;
  }
  return `${SITE_ORIGIN}/#${id}`;
}

export function locationsHubUrl() {
  return `${SITE_ORIGIN}/locations`;
}

export function tradesHubUrl() {
  return `${SITE_ORIGIN}/trades`;
}

export function localAreaUrl(slug) {
  return `${SITE_ORIGIN}/locations/${slug}`;
}

export function tradesAreaUrl(slug) {
  return `${SITE_ORIGIN}/trades/${slug}`;
}

export function tradesNicheUrl(tradeSlug, areaSlug) {
  return `${SITE_ORIGIN}/trades/${encodeURIComponent(String(tradeSlug).toLowerCase())}/${encodeURIComponent(String(areaSlug).toLowerCase())}`;
}
